import styles from './AnimatedBackground.module.css';

interface AnimatedBackgroundProps {
  children: React.ReactNode;
}

export function AnimatedBackground({ children }: AnimatedBackgroundProps) {
  return (
    <div className={styles.root}>
      <div className={styles.blobLime} />
      <div className={styles.blobViolet} />
      <div className={styles.blobOrange} />
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
}
